class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(),
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this),
        this.debouncedOnSubmit = debounce(event => {
            this.onSubmitHandler(event)
        }
        , 500),
        this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
        const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
        facetWrapper && facetWrapper.addEventListener("keyup", onKeyUpEscape);

        // ✅ Run facet de-dupe/merge/sort once on initial render
        setTimeout(() => FacetFiltersForm.postProcessFacets(), 0);
    }
    static stickyHeader = document.querySelector("sticky-header");
    static setListeners() {
        const onHistoryChange = event => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            searchParams !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(searchParams, null, !1)
        }
        ;
        window.addEventListener("popstate", onHistoryChange)
    }
    static toggleActiveFacets(disable=!0) {
        document.querySelectorAll(".js-facet-remove").forEach(element => {
            element.classList.toggle("disabled", disable)
        }
        )
    }
    static onClickDropdownSort(element) {
        if (!element.classList.contains("selected")) {
            const details = element.closest("details")
              , sortByElement = document.getElementById(details.dataset.sort);
            details.querySelector(".selected").classList.remove("selected"),
            element.classList.add("selected"),
            sortByElement.value = element.dataset.value,
            sortByElement.dispatchEvent(new Event("input",{
                bubbles: !0
            }))
        }
    }
    static renderPage(searchParams, event, updateURLHash=!0) {
        FacetFiltersForm.stickyHeader && (FacetFiltersForm.stickyHeader.preventResize = !0),
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"),
        sections.forEach(section => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
              , filterDataUrl = element => element.url === url;
            FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event)
        }
        ),
        updateURLHash && FacetFiltersForm.updateURLHash(searchParams),
        FacetFiltersForm.stickyHeader && (FacetFiltersForm.stickyHeader.preventResize = !1)
    }
    static renderSectionFromFetch(url, event) {
        fetch(url).then(response => response.text()).then(responseText => {
            const html = responseText;
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
                html,
                url
            }],
            FacetFiltersForm.renderFilters(html, event),
            FacetFiltersForm.renderProductGridContainer(html),
            FacetFiltersForm.renderProductCount(html)
        }
        )
    }
    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event),
        FacetFiltersForm.renderProductGridContainer(html),
        FacetFiltersForm.renderProductCount(html)
    }
    static renderProductGridContainer(html) {
        const productGridContainer = document.getElementById("ProductGridContainer");
        productGridContainer.innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer").innerHTML,
        FacetFiltersForm.stickyHeader && FacetFiltersForm.stickyHeader.dispatchEvent(new Event("preventHeaderReveal")),
        productGridContainer.scrollIntoView({
            behavior: "smooth"
        })
    }
    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount").innerHTML
          , container = document.getElementById("ProductCount")
          , containerDesktop = document.getElementById("ProductCountDesktop");
        container.innerHTML = count,
        container.classList.remove("loading"),
        containerDesktop && (containerDesktop.innerHTML = count,
        containerDesktop.classList.remove("loading"))
    }
    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html")
          , facetDetailsElementsFromFetch = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter")
          , facetDetailsElementsFromDom = document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");
        Array.from(facetDetailsElementsFromDom).forEach(currentElement => {
            Array.from(facetDetailsElementsFromFetch).some( ({id}) => currentElement.id === id) || currentElement.parentElement.remove()
        }
        );
        const matchesId = element => {
            const jsFilter = event ? event.target.closest(".js-filter") : void 0;
            return jsFilter ? element.id === jsFilter.id : !1
        }
          , countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
        facetDetailsElementsFromFetch.forEach( (elementToRender, index) => {
            if (event && event.target.closest(".js-filter") && event.target.closest(".js-filter").id === elementToRender.id)
                return;
            if (document.getElementById(elementToRender.id))
                document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
            else {
                if (index > 0) {
                    const {className: previousElementClassName, id: previousElementId} = facetDetailsElementsFromFetch[index - 1];
                    if (elementToRender.className === previousElementClassName) {
                        document.getElementById(previousElementId).parentElement.after(elementToRender.parentElement);
                        return
                    }
                }
                elementToRender.parentElement && document.querySelector(`#${elementToRender.parentElement.parentElement.id} .js-filter`).parentElement.before(elementToRender.parentElement)
            }
        }
        ),
        FacetFiltersForm.renderActiveFacets(parsedHTML),
        FacetFiltersForm.renderAdditionalElements(parsedHTML),
        countsToRender && FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));

        // ✅ Re-run facet de-dupe/merge/sort after facets HTML is replaced (AJAX)
        FacetFiltersForm.postProcessFacets();
    }
    static renderActiveFacets(html) {
        [".active-facets-mobile", ".active-facets-desktop"].forEach(selector => {
            const activeFacetsElement = html.querySelector(selector);
            activeFacetsElement && (document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML)
        }
        ),
        FacetFiltersForm.toggleActiveFacets(!1)
    }
    static renderAdditionalElements(html) {
        [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(selector => {
            html.querySelector(selector) && (document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML)
        }
        ),
        document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()
    }
    static renderCounts(source, target) {
        const targetElement = target.querySelector(".facets__selected")
          , sourceElement = source.querySelector(".facets__selected")
          , targetElementAccessibility = target.querySelector(".facets__summary")
          , sourceElementAccessibility = source.querySelector(".facets__summary");
        sourceElement && targetElement && (targetElement.outerHTML = sourceElement.outerHTML);
        const targetElementStr = target.querySelector(".facets__selected-str")
          , sourceElementStr = source.querySelector(".facets__selected-str");
        sourceElementStr && targetElementStr && (targetElementStr.outerHTML = sourceElementStr.outerHTML),
        targetElementAccessibility && sourceElementAccessibility && (target.querySelector(".facets__summary").outerHTML = source.querySelector(".facets__summary").outerHTML)
    }
    static updateURLHash(searchParams) {
        history.pushState({
            searchParams
        }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`)
    }
    static getSections() {
        return [{
            section: document.getElementById("product-grid").dataset.id
        }]
    }
    createSearchParams(form, ignoreSortBy=!1) {
        const formData = new FormData(form)
          , gtePrice = form.querySelector(".field__input--price-gte");
        gtePrice && gtePrice.value == gtePrice.min && formData.delete(gtePrice.name);
        const ltePrice = form.querySelector(".field__input--price-lte");
        return ltePrice && ltePrice.value * 1 == ltePrice.max * 1 && formData.delete(ltePrice.name),
        ignoreSortBy && formData.delete("sort_by"),
        new URLSearchParams(formData).toString()
    }
    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event)
    }
    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll("facet-filters-form form");
        if (event.srcElement.className == "mobile-facets__checkbox") {
            const searchParams = this.createSearchParams(event.target.closest("form"));
            this.onSubmitForm(searchParams, event)
        } else {
            const forms = []
              , isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";
            sortFilterForms.forEach(form => {
                if (isMobile)
                    form.id === "FacetFiltersFormMobile" && forms.push(this.createSearchParams(form));
                else if (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm")
                    document.querySelectorAll(".no-js-list").forEach(el => el.remove()),
                    event.target.closest("form").id == "FacetSortForm" ? forms.push(this.createSearchParams(form)) : forms.push(this.createSearchParams(form, !0));
                else if (event.target.closest("form").id == "FacetSortForm") {
                    const sortMobile = form.querySelector('[name="sort_by"]');
                    sortMobile && (sortMobile.value = event.target.value)
                }
            }
            ),
            this.onSubmitForm(forms.join("&"), event)
        }
    }
    onActiveFilterClick(event) {
        event.preventDefault(),
        FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(url)
    }
    static postProcessFacets() {
        try {
            document.querySelectorAll("details.js-filter").forEach(details => {
                const param = details.dataset.facetParam || FacetFiltersForm._inferFacetParam(details);
                if (!param || !param.includes("filter.p.m.custom."))
                    return;
                const list = details.querySelector("ul");
                list && FacetFiltersForm._mergeAndSortFacetList(details, list, param)
            }
            )
        } catch (e) {
            console.warn("[facets] postProcessFacets failed", e)
        }
    }
    static _inferFacetParam(details) {
        const m = (details.getAttribute("id") || "").match(/Details-(?:filter-)?p-m-custom-([a-z0-9_\-]+)/i);
        return m && m[1] ? `filter.p.m.custom.${m[1].replace(/\-/g, "_")}` : ""
    }
    static _getOptionMeta(li) {
        const input = li.querySelector("input.facets__checkbox-value")
          , labelEl = li.querySelector(".facet-checkbox__content__label")
          , countEl = li.querySelector(".facet-checkbox__content__count");
        return {
            input,
            labelEl,
            countEl,
            rawLabel: (labelEl ? labelEl.textContent : "").trim(),
            rawValue: input ? (input.value || "").trim() : "",
            count: countEl && parseInt((countEl.textContent || "0").replace(/[^0-9]/g, ""), 10) || 0
        }
    }
    static _canonLabelFor(param, label, value) {
        let s = (label || value || "").toString().replace(/\u00A0/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
        s = s.replace(/\bdisks\b/ig, "Discs").replace(/\bdisk\b/ig, "Disc"),
        s = s.replace(/”|“/g, '"').replace(/’/g, "'");
        const key = param.toLowerCase();
        if (key.includes("sheet_capacity")) {
            const m = s.match(/up\s*to\s*(\d+)/i);
            if (m)
                return `Up to ${m[1]} Sheets`;
            const n = s.match(/(\d+)/);
            return n ? `Up to ${n[1]} Sheets` : s
        }
        if (key.includes("speed")) {
            const m = s.match(/(\d+)\s*fpm/i);
            if (m)
                return `${m[1]} FPM`;
            const n = s.match(/(\d+)/);
            return n ? `${n[1]} FPM` : s
        }
        if (key.includes("motor_peak")) {
            const m = s.match(/(\d+(?:\.\d+)?)\s*hp/i);
            if (m)
                return `${m[1]} HP`;
            const n = s.match(/(\d+(?:\.\d+)?)/);
            return n ? `${n[1]} HP` : s
        }
        if (key.includes("waste_capacity")) {
            const m = s.match(/(\d+)\s*(?:gal|gallon)/i);
            if (m)
                return `${m[1]} Gal`;
            const n = s.match(/(\d+)/);
            return n ? `${n[1]} Gal` : s
        }
        if (key.includes("entry_width")) {
            const pm = s.match(/paper\s*:\s*([0-9.]+)\s*"?\s*;\s*disc[s]?\s*:\s*([0-9.]+)\s*"?/i);
            if (pm)
                return `Paper: ${pm[1]}"; Discs: ${pm[2]}"`;
            const m = s.match(/([0-9.]+)\s*"?/);
            return m ? m[0].replace(/\s+/g, "").replace(/^([0-9.]+)$/, "$1") : s
        }
        if (key.includes("cut_type")) {
            const norm = s.replace(/\s+/g, " ").trim();
            return /level\s*6/i.test(norm) && /p\s*[-–]?\s*7/i.test(norm) ? "DOD NSA/CSS Level 6 / P-7" : /p\s*[-–]?\s*7/i.test(norm) && /o\s*[-–]?\s*6/i.test(norm) ? norm.startsWith("DOD") ? "DOD P-7 & O-6 Cross Cut" : "P-7 & O-6 Cross Cut" : /dod\s*nsa\/css/i.test(norm) && !/level/i.test(norm) ? "DOD NSA/CSS" : norm
        }
        return key.includes("shred_size") && (s = s.replace(/\s*x\s*/ig, " x ").replace(/\s*mm\b/ig, "mm").replace(/\s+/g, " ").trim(),
        s = s.replace(/(^|\s)\.(\d)/g, "$10.$2")),
        s
    }
    static _groupKeyFor(param, canonLabel) {
        const key = param.toLowerCase()
          , s = (canonLabel || "").toString().trim().toLowerCase();
        if (key.includes("sheet_capacity")) {
            const m = s.match(/up\s*to\s*(\d+)/);
            return m ? `n:${m[1]}` : `t:${s}`
        }
        if (key.includes("speed")) {
            const m = s.match(/(\d+)\s*fpm/);
            return m ? `n:${m[1]}` : `t:${s}`
        }
        if (key.includes("motor_peak")) {
            const m = s.match(/(\d+(?:\.\d+)?)\s*hp/);
            return m ? `n:${m[1]}` : `t:${s}`
        }
        if (key.includes("waste_capacity")) {
            const m = s.match(/(\d+)\s*gal/);
            return m ? `n:${m[1]}` : `t:${s}`
        }
        if (key.includes("entry_width")) {
            const m = s.match(/paper\s*:\s*([0-9.]+).*disc[s]?\s*:\s*([0-9.]+)/);
            if (m)
                return `paper:${m[1]}-disc:${m[2]}`;
            const n = s.match(/([0-9.]+)/);
            return n ? `n:${n[1]}` : `t:${s}`
        }
        return `t:${s}`
    }
    static _sortKeyFor(param, canonLabel) {
        const key = param.toLowerCase()
          , s = (canonLabel || "").toString();
        let n = null;
        if (key.includes("sheet_capacity")) {
            const m = s.match(/Up to\s*(\d+)/i);
            m && (n = parseInt(m[1], 10))
        } else if (key.includes("speed")) {
            const m = s.match(/(\d+)\s*FPM/i);
            m && (n = parseInt(m[1], 10))
        } else if (key.includes("motor_peak")) {
            const m = s.match(/(\d+(?:\.\d+)?)\s*HP/i);
            m && (n = parseFloat(m[1]))
        } else if (key.includes("waste_capacity")) {
            const m = s.match(/(\d+)\s*Gal/i);
            m && (n = parseInt(m[1], 10))
        } else if (key.includes("entry_width")) {
            const m = s.match(/Paper:\s*([0-9.]+)"/i);
            if (m)
                n = parseFloat(m[1]);
            else {
                const m2 = s.match(/([0-9.]+)/);
                m2 && (n = parseFloat(m2[1]))
            }
        } else if (key.includes("shred_size")) {
            const m = s.match(/([0-9.]+)\s*mm/i) || s.match(/([0-9.]+)/);
            m && (n = parseFloat(m[1]))
        }
        return n !== null && !Number.isNaN(n) ? {
            type: 0,
            n,
            t: s.toLowerCase()
        } : {
            type: 1,
            n: 0,
            t: s.toLowerCase()
        }
    }
    static _mergeAndSortFacetList(details, list, param) {
        const items = Array.from(list.querySelectorAll("li"));
        if (!items.length || list.dataset.btMerged === "1")
            return;
        list.dataset.btMerged = "1";
        const groups = new Map;
        items.forEach(li => {
            const meta = FacetFiltersForm._getOptionMeta(li);
            if (!meta.input)
                return;
            const canon = FacetFiltersForm._canonLabelFor(param, meta.rawLabel, meta.rawValue)
              , gk = FacetFiltersForm._groupKeyFor(param, canon);
            if (!groups.has(gk))
                groups.set(gk, {
                    canonLabel: canon,
                    keep: li,
                    members: [li],
                    inputs: [meta.input],
                    totalCount: meta.count,
                    anyChecked: meta.input.checked === !0
                });
            else {
                const g = groups.get(gk);
                g.members.push(li),
                g.inputs.push(meta.input),
                g.totalCount += meta.count,
                meta.input.checked && (g.anyChecked = !0)
            }
        }
        ),
        groups.forEach(g => {
            const keepMeta = FacetFiltersForm._getOptionMeta(g.keep);
            keepMeta.labelEl && (keepMeta.labelEl.textContent = g.canonLabel),
            keepMeta.countEl && (keepMeta.countEl.textContent = String(g.totalCount)),
            keepMeta.input && (keepMeta.input.checked = g.anyChecked),
            keepMeta.input && !keepMeta.input.dataset.btGroupBound && (keepMeta.input.addEventListener("change", () => {
                const checked = keepMeta.input.checked === !0;
                g.inputs.forEach(inp => {
                    inp !== keepMeta.input && (inp.checked = checked)
                }
                )
            }
            ),
            keepMeta.input.dataset.btGroupBound = "1"),
            g.members.forEach( (li, idx) => {
                idx !== 0 && (li.style.display = "none",
                li.dataset.btMergedHidden = "1")
            }
            )
        }
        );
        const kept = Array.from(groups.values()).map(g => g.keep);
        kept.sort( (a, b) => {
            const ma = FacetFiltersForm._getOptionMeta(a)
              , mb = FacetFiltersForm._getOptionMeta(b)
              , ca = FacetFiltersForm._canonLabelFor(param, ma.rawLabel, ma.rawValue)
              , cb = FacetFiltersForm._canonLabelFor(param, mb.rawLabel, mb.rawValue)
              , ka = FacetFiltersForm._sortKeyFor(param, ca)
              , kb = FacetFiltersForm._sortKeyFor(param, cb);
            return ka.type !== kb.type ? ka.type - kb.type : ka.n !== kb.n ? ka.n < kb.n ? -1 : 1 : ka.t.localeCompare(kb.t)
        }
        ),
        kept.forEach(li => list.appendChild(li))
    }
}
FacetFiltersForm.filterData = [],
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1),
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1),
customElements.define("facet-filters-form", FacetFiltersForm),
FacetFiltersForm.setListeners();
function getElementStyle(element, property) {
    return window.getComputedStyle ? window.getComputedStyle(element, null).getPropertyValue(property) : element.style[property.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase()
    })]
}
class PriceRange extends HTMLElement {
    constructor() {
        super(),
        this.querySelectorAll('input:not([type="range"])').forEach(element => element.addEventListener("change", this.onRangeChange.bind(this))),
        this.querySelectorAll('input[type="range"]').forEach(element => {
            element.addEventListener("input", this.onRangeSliderInput.bind(this))
        }
        ),
        this.setMinAndMaxValues()
    }
    onRangeSliderInput(event) {
        const remainInput = document.getElementById(event.target.dataset.rangeInput);
        let delta = 0;
        event.target.classList.contains("range-slider__input--lower") ? Number.parseInt(event.target.value) >= Number.parseInt(remainInput.value) && (delta = -1) : Number.parseInt(event.target.value) <= Number.parseInt(remainInput.value) && (delta = 1),
        delta == 0 ? this.calculateRangeUsedBarWidth(event.target) : event.target.value = Number.parseInt(remainInput.value) + delta,
        document.getElementById(event.target.dataset.input).value = event.target.value / 100;
        const rangeValueElement = document.getElementById(event.target.dataset.rangeValue);
        rangeValueElement.innerHTML = Shopify.showPrice(event.target.value)
    }
    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget),
        this.setMinAndMaxValues();
        const rangeInputElement = document.getElementById(event.target.dataset.rangeInput);
        rangeInputElement.value = event.target.value,
        this.calculateRangeUsedBarWidth(rangeInputElement)
    }
    calculateRangeUsedBarWidth(rangeInput) {
        const value = Number(rangeInput.value)
          , max = Number(rangeInput.getAttribute("max"));
        let rangeUsedBarWidth;
        if (rangeInput.classList.contains("range-slider__input--lower"))
            rangeUsedBarWidth = value * 100 / max,
            this.style.setProperty("--range-used-start-width", rangeUsedBarWidth + "%");
        else {
            const min = Number(rangeInput.getAttribute("min"));
            rangeUsedBarWidth = (max - value) * 100 / (max - min),
            this.style.setProperty("--range-used-end-width", rangeUsedBarWidth + "%")
        }
    }
    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input:not([type="range"])')
          , minInput = inputs[0]
          , maxInput = inputs[1];
        maxInput.value && minInput.setAttribute("max", maxInput.value),
        minInput.value && maxInput.setAttribute("min", minInput.value),
        minInput.value === "" && maxInput.setAttribute("min", 0),
        maxInput.value === "" && minInput.setAttribute("max", maxInput.getAttribute("max"))
    }
    adjustToValidValues(input) {
        const value = Number(input.value)
          , min = Number(input.getAttribute("min"))
          , max = Number(input.getAttribute("max"));
        value < min && (input.value = min),
        value > max && (input.value = max)
    }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector("a");
        facetLink.setAttribute("role", "button"),
        facetLink.addEventListener("click", this.closeFilter.bind(this)),
        facetLink.addEventListener("keyup", event => {
            event.preventDefault(),
            event.code.toUpperCase() === "SPACE" && this.closeFilter(event)
        }
        )
    }
    closeFilter(event) {
        event.preventDefault(),
        (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(event)
    }
}
customElements.define("facet-remove", FacetRemove);
//# sourceMappingURL=/cdn/shop/t/14/assets/facets.js.map?v=86748874556650463431772972919
